(() => {
  const setupPagination = (container) => {
    if (!container || container.dataset.collectionsPaginationInitialized === 'true') return;

    const items = Array.from(container.querySelectorAll('[data-collections-page-item]'));
    const sentinel = container.querySelector('[data-collections-pagination]');

    if (items.length <= 1 || !sentinel) {
      items.forEach((item) => {
        item.hidden = false;
      });
      if (sentinel) {
        sentinel.hidden = true;
      }
      container.dataset.collectionsPaginationInitialized = 'true';
      return;
    }

    let visibleCount = 1;
    let observer;

    const revealVisibleItems = () => {
      items.forEach((item, index) => {
        item.hidden = index >= visibleCount;
      });
    };

    const updateSentinel = () => {
      sentinel.hidden = visibleCount >= items.length;
    };

    const observeCurrentEnd = () => {
      if (observer) {
        observer.disconnect();
      }

      updateSentinel();
      if (sentinel.hidden) {
        return;
      }

      const lastVisibleItem = items[Math.max(visibleCount - 1, 0)];
      if (!lastVisibleItem) {
        return;
      }

      observer = new IntersectionObserver((entries) => {
        const [entry] = entries;
        if (!entry || !entry.isIntersecting) {
          return;
        }

        visibleCount = Math.min(visibleCount + 1, items.length);
        revealVisibleItems();
        observeCurrentEnd();
      }, {
        rootMargin: '0px 0px 25% 0px'
      });

      observer.observe(lastVisibleItem);
    };

    revealVisibleItems();
    observeCurrentEnd();
    container.dataset.collectionsPaginationInitialized = 'true';
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-main-list-collections]').forEach(setupPagination);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
